import { Reveal } from "./Reveal";
import { Glyph } from "./Glyph";
import { ABOUT } from "../../content";

export const About = () => (
  <section id="about" tabIndex={-1} data-testid="about-section" className="relative py-20 sm:py-28 border-t border-[#B59A5B]/20 outline-none">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="font-caps text-[11px] sm:text-xs tracking-[0.35em] uppercase text-[#C9AD6A] flex items-center gap-3">
          <span className="h-px w-10 bg-[#B59A5B]/70" /> About Us
        </p>
      </Reveal>
      <div className="mt-10 sm:mt-14 grid gap-12 md:grid-cols-2 md:gap-16">
        {ABOUT.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.12}>
            <article data-testid={`about-${p.id}`} className="border-t border-[#B59A5B]/25 pt-8">
              <Glyph type={p.glyph} className="w-11 h-11 text-[#C9AD6A]" />
              <h3 className="mt-6 font-display text-3xl sm:text-4xl font-light text-[#FAF6ED]">{p.name}</h3>
              <p className="mt-3 font-caps text-[11px] sm:text-xs tracking-[0.18em] uppercase leading-relaxed text-[#C9AD6A]">{p.roles}</p>
              <p className="mt-5 text-[15px] sm:text-base leading-relaxed text-[#FAF6ED]/80 font-body">{p.body}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
